import ReturnsRmaTable from './ReturnsRmaTable';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsRmaTable);
